import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupName,
} from '@angular/forms';
import * as _ from 'lodash';
import { PrFormAbstract } from '../pr-form.abstract';

@Component({
    selector: 'pr-subform',
    templateUrl: './pr-subform.component.html',
    styleUrls: ['./pr-subform.component.scss'],
    standalone: false
})
export class PrSubformComponent implements OnInit, AfterViewInit {
  @Input() derrors: boolean = false;

  @Input() formGroupName: FormGroupName;

  @Input() formGroup: UntypedFormGroup;

  @Input() index: number;

  @Input() context;

  @Input() submitbtnLabel: string = 'Valider';

  @ViewChild('formContainer', { static: true }) formContainer: ElementRef;

  @ContentChild(PrFormAbstract, { static: true }) form: PrFormAbstract;

  @Output() onOpen: EventEmitter<number> = new EventEmitter();

  @Output() onDelete: EventEmitter<number> = new EventEmitter();

  @Output() onCancel: EventEmitter<number> = new EventEmitter();

  @Output() onValidate: EventEmitter<any> = new EventEmitter();

  _default = {};

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    if (!this.form) this.form = this.context;
  }

  open() {
    if (this.form) this._default = _.clone(this.form.form.value);
    this.formContainer.nativeElement.classList.add('open');
    this.onOpen.emit();
  }

  close() {
    this.formContainer.nativeElement.classList.remove('open');
  }

  cancel() {
    if (this.form && this.form.form) this.form.form.patchValue(this._default);
    else if (this.form) this.form.reset();
    this.onCancel.emit();
    this.close();
  }

  validate() {
    if (
      this.form.form.status === 'VALID' ||
      this.formGroup.status === 'VALID'
    ) {
      this.onValidate.emit(this.formGroup.controls);
      this.close();
    } else {
      this.form.displayErrors();
    }
  }

  delete() {
    this.onDelete.emit(this.index);
  }
}
